import styled from 'styled-components';

export const FooterWrapper = styled.div`
  color: ${(props) => props.theme.colors.muted};
`;

export const CustomFieldsWrapper = styled.div`
  margin-top: 0px;
`;

export const CustomStorageCardWrapper = styled.div`
  margin-top: 32px;
`;

export const MapDivider = styled.div`
  width: 3%;
  margin: 0 10px;
  height: 1px;
  border: none;
  background-color: #c5d0db;
  position: relative;
`;

export const MapWrapper = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const MappingInputWrapper = styled.div`
  width: 100%;
`;

export const CustomMapWrapper = styled.div`
  margin-top: 32px;
  margin-bottom: 32px;
`;
